import { useEffect, useState } from 'react';
import { usePageTitle } from '../../contexts/PageTitleContext';
import { Card } from '../../components/base/Card';
import { Chat } from '../../components/Orbit/Chat';
import { ChatHistory } from '../../components/Orbit/ChatHistory';
import { Button } from '../../components/base/Button';
import useOrbitChatHistory from '../../data/orbit/useOrbitChatHistory';

function generateChatId(): string {
  if (typeof globalThis !== 'undefined' && globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

export function OrbitPage() {
  const { chats } = useOrbitChatHistory();
  const { setPageTitle } = usePageTitle();
  const [selectedChatId, setSelectedChatId] = useState<string | undefined>(
    undefined
  );
  const [selectedChatTitle, setSelectedChatTitle] = useState<
    string | undefined
  >(undefined);
  const [newChatId, setNewChatId] = useState(generateChatId);

  useEffect(() => {
    setPageTitle('Orbit');
  }, [setPageTitle]);

  const handleNewChat = () => {
    setSelectedChatId(undefined);
    setSelectedChatTitle(undefined);
    setNewChatId(generateChatId());
    chats.refetch();
  };

  const handleSelectChat = (id: string, title: string) => {
    setSelectedChatId(id);
    setSelectedChatTitle(title);
  };

  const chatId = selectedChatId ?? newChatId;

  return (
    <div className="grid grid-cols-4 gap-6 h-[calc(100vh-320px)] max-h-[calc(100vh-320px)] min-h-96">
      <div className="h-full min-h-0">
        <Card className="h-full overflow-hidden">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-medium dark:text-white">Chats</h2>
            <Button size="sm" onClick={handleNewChat}>
              New Chat
            </Button>
          </div>
          <div className="pt-8 pb-4">
            <ChatHistory
              selectedChatId={selectedChatId}
              onSelectChat={handleSelectChat}
            />
          </div>
        </Card>
      </div>
      <div className="col-span-3 h-full min-h-0">
        <Card className="!p-0 h-full overflow-hidden">
          <Chat
            key={chatId}
            className="h-full"
            chatId={chatId}
            chatTitle={selectedChatTitle}
            isExistingChat={!!selectedChatId}
          />
        </Card>
      </div>
    </div>
  );
}
